import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {EvaluationReportTable} from './table/EvaluationReportTable'
import {KTCard} from '../../../../../../_metronic/helpers'
import {EvaluationReportListHeader} from './components/header/EvaluationReportListHeader'

const EvaluationReportList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard className='pb-5 mb-2'>
        <EvaluationReportListHeader />
      </KTCard>
      <KTCard>
        <EvaluationReportTable />
      </KTCard>
      {itemIdForUpdate !== undefined}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const EvaluationReportsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <EvaluationReportList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {EvaluationReportsListWrapper}
